import { makeStyles, Typography } from '@material-ui/core';
import { Variant } from '@material-ui/core/styles/createTypography';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  baseStyles: {
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  phoneLink: {
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.primary.main,
      textDecoration: 'underline'
    }
  },
}));

interface PhoneLineProps {
  phoneNumber: string;
  variant?: Variant;
  color?: 'initial' | 'inherit' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error';
  text?: string;
}

export const PhoneNumber = ({ phoneNumber, variant = 'h5', color = 'primary', text }: PhoneLineProps) => {
  const classes = useStyles();

  const purePhoneNumber = phoneNumber.replace(/-/g, '');

  return (
    <a href={`tel:+${purePhoneNumber}`} className={classes.phoneLink}>
      <Typography variant={variant} color={color} display="inline" className={classes.baseStyles}>
        {text ? text : phoneNumber}
      </Typography>
    </a>
  );
};
